// extracted by mini-css-extract-plugin
export default {"table_container":"inventory_table_container__IFxxa","image":"inventory_image__aMRCs"};